
namespace Gamification.Gamification {

    @Serenity.Decorators.registerEditor()
    export class SmtpSecureSocketOptionsEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);

            this.addItem({
                id: "0",
                text: "None"
            });

            this.addItem({
                id: "1",
                text: "Auto"
            });

            this.addItem({
                id: "2",
                text: "SslOnConnect"
            });

            this.addItem({
                id: "3",
                text: "StartTls"
            });

            this.addItem({
                id: "4",
                text: "StartTlsWhenAvailable"
            });
        }
    }
}